import { lazy, Suspense } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';

import { DashboardLayout } from 'src/layouts/dashboard';
import { RouteErrorView } from 'src/pages/error/route-error-view';

import { LoadingScreen } from 'src/components/loading-screen';
import { PageTransition } from 'src/components/animate/page-transition';

import { AuthGuard } from 'src/auth/guard';

import { authRoutes } from './auth';
import { mainRoutes } from './main';
import { chatRoutes } from './chat';
import { accountRoutes } from './account';
import { paycardRoutes } from './paycard';
import { miscRoutes } from './miscellaneous';
import { reportingRoutes } from './reporting';
import { managementRoutes } from './management';
import { aboveStoreRoutes } from './above-store';

// ----------------------------------------------------------------------

// Pages
const HomePage = lazy(() => import('src/pages/home'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <PageTransition>
        <Outlet />
      </PageTransition>
    </Suspense>
  </DashboardLayout>
);

export function Router() {
  return useRoutes([
    {
      element: <Outlet />,
      errorElement: <RouteErrorView />,
      children: [
        {
          path: '/',
          /**
           * Skip home page
           * element: <Navigate to={CONFIG.auth.redirectPath} replace />,
           */
          // element: <Navigate to={CONFIG.auth.redirectPath} replace />,
          element: <AuthGuard>{layoutContent}</AuthGuard>,
          children: [
            { element: <HomePage />, index: true },
          ],
        },

        // Auth
        ...authRoutes,

        // Account
        ...accountRoutes,

        // Main
        ...mainRoutes,

        // Chat
        ...chatRoutes,

        // Reporting
        ...reportingRoutes,

        // Paycard
        ...paycardRoutes,

        // Management
        ...managementRoutes,

        // Miscellaneous
        ...miscRoutes,

        // Above Store
        ...aboveStoreRoutes,

        // No match
        { path: '*', element: <Navigate to="/404" replace /> },
        { element: <HomePage />, index: true },
      ],
    },
  ]);
}
